import { accountMessagesStyles } from "@insite/content-library/Widgets/MyAccount/AccountMessages";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

accountMessagesStyles.messagesAccordionSection = {
    headerProps: {
        css: css`
            button {
                border-radius: 4px;
                background: #f0f4f3;
                border: none;
                > ${TypographyStyle} {
                    font-size: 20px;
                    padding: 0 1rem;
                    font-family: "LibreBaskerville";
                    font-weight: normal;
                }
                &:focus {
                    border: 0 solid transparent;
                }
            }
        `,
    },
    panelProps: {
        css: css`
            max-height: 500px;
            overflow-y: auto;
            border: 0;
            padding: 15px 27px;
        `,
    },
};
accountMessagesStyles.noMessagesText = {
    size: 16,
    css: css`
        margin-bottom: 20px;
    `,
};
